import axios from 'axios'
import _ from 'lodash'
import { toast } from 'react-toastify'

class ApiService {
    constructor() {
        this.url = process.env.REACT_APP_API_URL + '/api/v1'
        this.headers = {}
        this.refreshAuthHeaders()
    }

    async get(url) {
        try {
            const response = await axios.get(this.url + url, { headers: this.headers })
            return response.data
        } catch (error) {
            this.handleServerError(error)
            return null
        }
    }

    async delete(url) {
        try {
            const response = await axios.delete(this.url + url, { headers: this.headers })
            return response.data
        } catch (error) {
            this.handleServerError(error)
            return null
        }
    }

    async post(url, data) {
        try {
            const response = await axios.post(this.url + url, data, { headers: this.headers })
            return response.data
        } catch (error) {
            this.handleServerError(error)
            return null
        }
    }

    async put(url, data) {
        try {
            const response = await axios.put(this.url + url, data, { headers: this.headers })
            return response.data
        } catch (error) {
            this.handleServerError(error)
            return null
        }
    }

    handleServerError(error) {
        console.error(error)
        const status = _.get(error, 'response.status', null)
        if (status === 401 && window.location.pathname !== '/login') window.location.replace('/login')
        toast.error('Αδυναμία εκτέλεσης! Δοκιμάστε ξανά.', {
            position: 'top-right',
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            theme: 'colored'
        })
    }

    refreshAuthHeaders() {
        const token = localStorage.getItem(`robot-token`)
        if (!token) return
        this.headers.Authorization = `Bearer ${token}`
    }
}

export default new ApiService()
